<div  class="header" appBg="primary" brightness="darker">
    <a (click)="cancel()" appIconColor class="d-flex align-items-center"><i class="fas fa-chevron-left"></i><h5 class="my-2 ml-2">{{Localization.Back | translate}}</h5></a>
    <h5 class="my-2">{{ Localization.AddIssue | translate }}</h5>
    <a disabled="isIssueCreating" (click)="onSubmit()" appIconColor><h5 class="my-2">{{ Localization.Save | translate }}</h5></a>
</div>
<ng-container *ngIf="!isIssueCreating; else isLoading">
    <div class="body" [ngClass]="{ 'adjustable': !showAddJobButton }">
        <form [formGroup]="formGroup">
            <div class="section">
                <div class="section-header">
                    <img src="assets/images/issues/location.svg" class="mr-2" width="24" [ngClass]="{'validated': !buildingFormControl.invalid}">
                    <h3 class="modal-title w-100 lite-title" [translate]="Localization.Location"></h3>
                </div>
                <div class="section-body">
                    <div class="issue-dialog-selects">
                        <mat-form-field class="mt-2"><!---->
                            <mat-label>{{Localization.Building | translate}}</mat-label>
                            <mat-select [formControl]="buildingFormControl" cdkFocusInitial>
                                <mat-option *ngFor="let building of buildings" [value]="building.id">
                                    {{building.label || formatAddress(building.address) }} ({{ building.application }} )
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                        <mat-form-field>
                            <mat-label>{{Localization.Level | translate}}</mat-label>
                            <mat-select [formControl]="levelFormControl">
                                <mat-option *ngFor="let level of levels" [value]="level.id">{{level.label}}</mat-option>
                            </mat-select>
                        </mat-form-field>
                        <mat-form-field *ngIf="locations.length >= 1">
                            <mat-label>{{Localization.Location | translate}}</mat-label>
                            <mat-select [formControl]="locationFormControl">
                                <mat-option *ngFor="let location of locations" [value]="location.id">{{location.label}}</mat-option>
                            </mat-select>
                        </mat-form-field>
                        <mat-form-field>
                            <mat-label>{{Localization.Element | translate}}</mat-label>
                            <mat-select [formControl]="locationElementFormControl">
                                <mat-optgroup *ngFor="let categoryGroup of elementCategoryGroup" [label]="categoryGroup.category">
                                    <mat-option *ngFor="let element of categoryGroup.elements" [value]="element.id">{{element.label}}</mat-option>
                                </mat-optgroup>
                            </mat-select>
                        </mat-form-field>
                    </div>
                </div>
            </div>
            <div class="section">
                <div class="section-header">
                    <img src="assets/images/issue-categories/thick/{{kindOfProblemLabel}}.svg" class="mr-2" width="24" [ngClass]="{'validated': !kindOfProblemFormControl.invalid}">
                    <h3 class="modal-title w-100 lite-title" [translate]="Localization.Observation"></h3>
                </div>
                <div class="section-body">
                    <div class="issue-dialog-selects">
                        <mat-form-field>
                            <mat-label>{{Localization.KindOfProblem | translate}}</mat-label>
                            <mat-select [formControl]="kindOfProblemFormControl">
                                <mat-option *ngFor="let problem of kindOfProblems" [value]="problem.id">
                                    <img src="assets/images/issue-categories/{{problem.id}}.svg" class="mr-2" width="24">
                                    <span>{{problem.label}}</span>
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                        <mat-form-field>
                            <mat-label>{{Localization.Observation | titlecase}}</mat-label>
                            <textarea matInput [formControl]="observationFormControl"></textarea>
                        </mat-form-field>
                        <mat-form-field class="media-select">
                            <mat-select [formControl]="filesFormControl" (click)="fileInput.click()" [placeholder]="Localization.Media | translate" multiple></mat-select>
                            <input hidden (change)="onFileSelected($event)" #fileInput type="file" id="file">
                            <div class="d-flex flex-row" *ngIf="multimedia != []">
                                <div *ngFor="let multimedium of multimedia; index as i" class="image-list">
                                    <img [src]="multimedium.url" class="thumbnail" (click)="openMediaInMultimediaViewer(i)">
                                </div>
                            </div>
                        </mat-form-field>
                    </div>
                </div>
            </div>

            <div class="section">
                <div class="d-flex justify-content-end toggle-jobs">
                    <button type="button" class="job-add pull-right" (click)="addJob()" *ngIf="showAddJobButton; else removeJob">
                    <img src="assets/icons/add.svg" class="mr-1">
                    <span aria-hidden="true">{{ Localization.AddJob | translate | uppercase}}</span>
                    </button>
                </div>
            </div>
            <div class="section" *ngIf="!showAddJobButton">
                <div class="section-header">
                    <img src="assets/images/issue-actions/thick/{{jobLabel}}.svg" class="mr-2" width="24" [ngClass]="{'validated': !actionTypeFormControl.invalid}">
                    <h3 class="modal-title w-100 lite-title" [translate]="Localization.Observation"></h3>
                </div>
                <div class="section-body">
                    <div class="issue-dialog-selects">
                        <mat-form-field>
                            <mat-label>{{Localization.TypeOfJob | translate}}</mat-label>
                            <mat-select [formControl]="actionTypeFormControl" (selectionChange)="onActionTypeChange($event)">
                                <mat-option *ngFor="let type of actionTypes" [value]="type.id">{{type.label}}</mat-option>
                            </mat-select>
                        </mat-form-field>
                        <mat-form-field>
                            <mat-label>{{Localization.Executor | translate}}</mat-label>
                            <mat-select [formControl]="executorFormControl" (selectionChange)="onExecutorChange($event)">
                                <mat-option *ngFor="let executor of executors" [value]="executor.id">{{executor.label}}</mat-option>
                                <mat-option [value]="Localization.ToBeAssigned | translate">{{Localization.ToBeAssigned | translate}}</mat-option>
                            </mat-select>
                        </mat-form-field>
                        <mat-form-field *ngIf="showActionStatus">
                            <mat-label>{{Localization.JobStatus | translate}}</mat-label>
                            <mat-select [formControl]="actionStatusTypeFormControl">
                                <mat-option *ngFor="let status of jobStatuses" [value]="status.id">{{status.label}}</mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                </div>
            </div>
        </form>
    </div>
</ng-container>

<ng-template #removeJob>
    <button type="button" class="job-add pull-right" (click)="addJob()">
        <img src="assets/icons/remove.svg" class="mr-1">
        <span aria-hidden="true">{{ Localization.RemoveJob | translate | uppercase}}</span>
      </button>
</ng-template>
<chapps-multimedia-viewer></chapps-multimedia-viewer>

<ng-template #isLoading>
    <app-card-spinner [show]="true"></app-card-spinner>
</ng-template>
